exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.Table-Table_1YoVd .Table-rt-th_t-E8j {\n  color: red !important; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Table/Table.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,sBAAsB,EAAE","file":"Table.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Table .rt-th {\n  color: red !important; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Table": "Table-Table_1YoVd",
	"rt-th": "Table-rt-th_t-E8j"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/Table/Table.scss
// module id = 1600
// module chunks = 0